import { colors, screen } from 'components/styles/variables';
import { VehicleOverviewInterface } from 'lib/AutolistAPI';
import Markdown from 'components/ContentfulMarkdown';

export default function VehichleOverview({
  vehicleOverview,
}: {
  vehicleOverview: VehicleOverviewInterface;
}): JSX.Element {
  return (
    <div className="vehicle-overview-container">
      <div className="divider" />
      <h2 className="vehicle-overview-title">{vehicleOverview.title}</h2>
      <Markdown source={vehicleOverview.body} className="content" />
      <style jsx>{`
        @media screen and (max-width: ${screen.mdMax}) {
          .vehicle-overview-container {
            padding: 0 16px;
          }
        }

        .vehicle-overview-container {
          margin-bottom: 24px;
        }

        :global(.content img) {
          width: 100%;
          height: auto;
        }

        .divider {
          height: 1px;
          width: 100%;
          background-color: ${colors.G2};
          margin-bottom: 24px;
        }

        .vehicle-overview-title {
          font-size: 20px;
          font-weight: 700;
          line-height: 26px;
          letter-spacing: 0.2px;
        }
      `}</style>
    </div>
  );
}
